import { timer, switchMap, Subscription } from 'rxjs';
import { recordCourseUsage } from "@/api/user";

export interface UsageSenderParams {
	a: string;
	b: string;
	c: string;
	d: string;
	e: string;
	f: string;
	g?: string;
    h?: string;
	j?: string;
}

export default class {
    private period: number = 30000;
    private params: UsageSenderParams;
    private subscription: Subscription | null = null;
    constructor(params: UsageSenderParams, period?: number) {
        this.params = params;
        if (period) {
            this.period = period;
        }
        this.subscription = this.create();
    }
    private request() {
        return recordCourseUsage(this.params);
    }
    private create() {
        return timer(0, this.period)
            .pipe(switchMap(() => this.request()))
            .subscribe({
                error: err => console.error('Usage Sender Error: ' + err),
                complete: () => console.log('Usage Sender Done'),
            });
    }
    public stop() {
        this.subscription?.unsubscribe();
    }
    public updateParams(params: UsageSenderParams) {
        this.params = params;
    }
}

export function getSystem(){
    const userAgent = window.navigator.userAgent;
    if (userAgent.indexOf("Windows NT") !== -1) return "Windows";
    if (userAgent.indexOf("Mac") !== -1) return "Mac";
    if (userAgent.indexOf("X11") !== -1) return "UNIX";
    if (userAgent.indexOf("Linux") !== -1) return "Linux";
    return null;
}
